import { PlanCategory } from "../types/account.model";
import type { Account } from "../types/account.model";

export const DEFAULT_ACCOUNT: Account = {
  // id: accountId,
  slug: "s5f9on73",
  name: "Account1",
  owner: 2,
  status: 1,
  website: "test.com",
  type: 1,
  industry: 28,
  size: 3,
  subscription_id: "",
  // users_history: {},
  // created_on: "2022-01-05T17:55:22.742686Z",
  // updated_on: "2022-02-07T09:12:28.384343Z",
  // areas_of_interest: [],
  // phone_country: "us",
  // phone_number: "",
  // phone_extension: "",
  // location_country: "Ukraine",
  // location_country_code: "",
  // location_state: "Львівська область",
  // location_city: "Lviv",
  // location_zip: "79070",
  // location_address: "Hotkevycha",
  // location_address2: "",
  // location_point: null,
  // language: "en",
  timezone: "GMT",
  // locale: "en-US",
  // monday: {
  //   lower: 510,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // tuesday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // wednesday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // thursday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // friday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // saturday: {
  //   empty: true,
  // },
  // sunday: {
  //   empty: true,
  // },
  // theme: "smartsuite_premium",
  // color: "blue",
  is_personalization_supported: true,
  // logo: null,
  // metrics: null,
  // licensed_users: 0,
  // subscription_status: "",
  // subscription_trial: false,
  // subscription_start: "",
  // subscription_end: "",
  plan: {
    id: "smartsuite-trial-30",
    category: PlanCategory.Free,
    members_limit: null,
    number_of_solutions: 25,
    allow_solutions_overage: false,
    // records_per_solution: 5000,
    records_per_solution: null,
    allow_records_overage: false,
    file_storage: 1024,
    allow_storage_overage: false,
    days_in_recycle_bin: 30,
    features: {
      app_permissions: false,
      field_permissions: false,
      lock_view: false,
      view_folders: false,
      sso: false,
      mfa: false,
    },
  },
  // settings: {
  //   member_directory_filter: {
  //     type: 1,
  //     included_members: [],
  //   },
  // },
  // imageURL: "",
};

export const EMPTY_ACCOUNT: Account = {
  // id: "",
  slug: "",
  name: "",
  owner: 2,
  status: 1,
  website: "",
  type: 1,
  industry: 28,
  size: 3,
  subscription_id: "",
  // users_history: {},
  // created_on: "2022-01-05T17:55:22.742686Z",
  // updated_on: "2022-02-07T09:12:28.384343Z",
  // areas_of_interest: [],
  // phone_country: "us",
  // phone_number: "",
  // phone_extension: "",
  // location_country: "",
  // location_country_code: "",
  // location_state: "",
  // location_city: "",
  // location_zip: "",
  // location_address: "",
  // location_address2: "",
  // location_point: null,
  // language: "en",
  timezone: "GMT",
  // locale: "en-US",
  // monday: {
  //   lower: 510,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // tuesday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // wednesday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // thursday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // friday: {
  //   lower: 480,
  //   upper: 1020,
  //   bounds: "[)",
  // },
  // saturday: {
  //   empty: true,
  // },
  // sunday: {
  //   empty: true,
  // },
  // theme: "smartsuite_premium",
  // color: "blue",
  is_personalization_supported: true,
  // logo: null,
  // metrics: null,
  // licensed_users: 0,
  // subscription_status: "",
  // subscription_trial: false,
  // subscription_start: "",
  // subscription_end: "",
  plan: {
    id: "smartsuite-trial-30",
    category: PlanCategory.Free,
    members_limit: null,
    number_of_solutions: 25,
    allow_solutions_overage: false,
    records_per_solution: null,
    allow_records_overage: false,
    file_storage: 1024,
    allow_storage_overage: false,
    days_in_recycle_bin: 30,
    features: {
      app_permissions: false,
      field_permissions: false,
      lock_view: false,
      view_folders: false,
      sso: false,
      mfa: false,
    },
  },
  // settings: {
  //   member_directory_filter: {
  //     type: 1,
  //     included_members: [],
  //   },
  // },
  // imageURL: "",
};
